import React, { useState } from 'react';
import './emp-payroll.css';
import { FaUser } from "react-icons/fa6";
import { IoEye } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { Row, Col, Dropdown, ButtonGroup, Button, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PayrollInfoLayout from '../../../components/PayrollInfoLayout.jsx';

// Sample Employee data with pagination mock
const empData = Array.from({ length: 50 }, (_, index) => ({
  id: index + 1,
  name: `Hafiz Ayub ${index + 1}`,
  department: 'Human Resource',
  JobTitle: 'HR manager',
  Role: 'Employee',
  Gender: 'Male',
  Status: 'Married',
  Salary: '00000',

}));

export default function Paid() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);

  // Paginate data
  const paginatedData = empData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(empData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(empData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  // Function to handle opening the modal
  const handleViewClick = (emp) => {
    setSelectedEmp(emp);
    setShowModal(true);
  };

  // Function to handle closing the modal
  const handleClose = () => setShowModal(false);

  return (
    <>
      <PayrollInfoLayout>
        <h1 className='emps-payroll-title'><FaUser />Employee's Name</h1>
        <hr />
        <div className="emps-payroll-content">
          <div>
            <div className="entries-search-container">
              <Row>
                <Col xs={12} md={6} className="d-flex align-items-center mb-2">
                  <Dropdown as={ButtonGroup}>
                    <Button variant="primary">Show Entries</Button>
                    <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                      <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={6} className="d-flex justify-content-end mb-3 search-container">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="search-input"
                    />
                  </Form>
                </Col>
              </Row>
            </div>
            <div className="table-responsive">
              <table className='table table-striped'>
                <thead className='table-header'>
                  <tr className="emps-payroll-table-header">
                    <th>SR</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Worked Hours</th>
                    <th>OverTime Hours</th>
                    <th>Hourly Rate</th>
                    <th>OverTime Rate</th>
                    <th>Net Pay</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((emp, index) => (
                    <tr className="table-row" key={emp.id}>
                      <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                      <td>2023-09-01</td> {/* Start Date placeholder */}
                      <td>2023-09-30</td> {/* End Date placeholder */}
                      <td>September</td> {/* Month placeholder */}
                      <td>2023</td> {/* Year placeholder */}
                      <td>160</td> {/* Worked Hours placeholder */}
                      <td>10</td> {/* OverTime Hours placeholder */}
                      <td>20</td> {/* Hourly Rate placeholder */}
                      <td>30</td> {/* OverTime Rate placeholder */}
                      <td>{emp.Salary}</td> {/* Net Pay placeholder */}
                      <td>{emp.Status}</td>
                      <td>
                        <Button
                          className='btn btn-primary'
                          onClick={() => handleViewClick(emp)}
                        >
                          <IoEye />
                        </Button>
                        <Link to='/payroll'>
                          <Button className='btn btn-warning'><IoDocumentText /></Button>
                        </Link>
                        <Button className='btn btn-danger'><RiDeleteBin5Line /></Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className='table-footer'>
                  <tr className='emps-payroll-table-footer'>
                    <td>Total</td>
                    <td>-</td>
                    <td>0</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
              <div className="pagination-container">
                <Row className="custom-row">
                  <Col xs={12} md={9} className="custom-col-left">
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, empData.length)} of {empData.length} entries
                  </Col>
                  <Col xs={12} md={3} className="custom-col-right">
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage - 1);
                            }}
                          >
                            Previous
                          </a>
                        </li>
                        {pageRange().map(pageNumber => (
                          <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(pageNumber);
                              }}
                            >
                              {pageNumber}
                            </a>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === Math.ceil(empData.length / rowsPerPage) ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage + 1);
                            }}
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        {selectedEmp && (
  <Modal show={showModal} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Employee Payroll Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {/* Dialog-based content */}
      <div className="dialog-details">
        <h5>Payroll Information for {selectedEmp.name}</h5>
        <p>
          <strong>Start Date:</strong> 2023-09-01
        </p>
        <p>
          <strong>End Date:</strong> 2023-09-30
        </p>
        <p>
          <strong>Month:</strong> September
        </p>
        <p>
          <strong>Year:</strong> 2023
        </p>
        <p>
          <strong>Worked Hours:</strong> 160
        </p>
        <p>
          <strong>OverTime Hours:</strong> 10
        </p>
        <p>
          <strong>Hourly Rate:</strong> 20
        </p>
        <p>
          <strong>OverTime Rate:</strong> 30
        </p>
        <p>
          <strong>Net Pay:</strong> {selectedEmp.Salary}
        </p>
        <p>
          <strong>Status:</strong> {selectedEmp.Status}
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)}

      </PayrollInfoLayout>
    </>
  );
}
